export default "__VITE_ASSET__DXIdn4NL__"